import e from"styled-components";const o=e.div`
	position: relative;
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: ${({shouldChangeHeight:e})=>e?"240px":"280px"};
	justify-content: flex-end;
	padding: 12px 14px;
	overflow: hidden;
	box-sizing: border-box;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
		pointer-events: none;
		z-index: 1;
		border-bottom-left-radius: ${({borderRadius:e})=>`${e}px`};
		border-bottom-right-radius: ${({borderRadius:e})=>`${e}px`};
	}
`,t=e.h1`
	margin: 0;
	font-size: 22px;
	color: white;
	font-weight: 500;
	z-index: 2;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,i=e.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	color: #ffffff;
	white-space: pre-wrap;
	z-index: 2;
	opacity: 0.6;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`;export{o as CardContainer,t as CardHeading,i as CardParagraph};
